import React, { Fragment, useState, useEffect } from "react";
import {
    Row, Col,
    Modal, ModalHeader, ModalBody, Label, Input, Form, FormGroup, Button, ModalFooter
} from "reactstrap";
import { useForm } from "react-hook-form";
import { saveGender, saveSalutation, } from "../../../api";
import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";
import GetModalFooter from "../../common/getModalFooter";


const AddSalutation = (props) => {

    const { register, handleSubmit, errors, setValue, trigger, formState, getValues } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);


    const submitForm = async (data) => {
        const formData = data;
        console.log(formData, "formData");
        setIsSubmitting(true);
        await saveSalutation(formData)
            .then((res) => {
                if (res.status === 200) {
                    SweetAlert.fire({ title: "Salutation created successfully", icon: "success" }).then((res) => {
                        setIsSubmitting(false);
                        props.toggle();
                        props.refreshPage();
                    });
                }
            }).catch((err) => {
                console.log(err.response, "response")
                toast.error(err.response.data.error)
                setIsSubmitting(false);
            });
    };

    return (
        <Fragment>
            <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg" backdrop="static">
                <ModalHeader toggle={props.toggle}>{"Add Salutation"}</ModalHeader>
                <ModalBody>
                    <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                        <Row>
                            <Col xl="12" md="12">
                                <Row>
                                    <Col xl="6" md="6">
                                        <FormGroup>
                                            <Label>{"Title"}</Label><sup style={{ fontSize: "medium", top: 0 }} className="text-danger fs-1">*</sup>
                                            <Input
                                                className="form-control"
                                                name="title"
                                                type="text"
                                                innerRef={register({ required: true })}
                                            />
                                            <span style={{ color: "red" }}>
                                                {errors.title && errors.title.type === "required" && <span>Title is required</span>}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <GetModalFooter handleSubmit={handleSubmit} isSubmitting={isSubmitting} toggle={props.toggle} mode="add" />
                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default AddSalutation;